import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipModule, TooltipOptions } from '@cloudfactorydk/ng2-tooltip-directive';
import { IonicModule } from '@ionic/angular';
import { ProductPartInfoInteractionComponentModule } from 'src/app/shop/productos/product-part-info-interaction/product-part-info-interaction.module';
import { DefaultTooltipOptions } from '../../../home-new/default-tooltip-options';
import { ProductVariantsModule } from "../../../shop/productos/product-variants/product-variants.module";
import { QtyStepperModule } from '../qty-stepper/qty-stepper.module';
import { AddToCartStepsComponent } from './add-to-cart-steps/add-to-cart-steps.component';
import { ProductCardInfoModule } from './product-card-info/product-card-info.module';
import ProductCardComponent from './product-card.component';
import { ProductLabelModule } from './product-label/product-label.module';
import { ProductPriceModule } from './product-price/product-price.module';

@NgModule({
  declarations: [
    ProductCardComponent,
    ProductCardComponent,
    AddToCartStepsComponent
  ],
  exports: [
    ProductCardComponent,
    ProductCardComponent,
    AddToCartStepsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    ProductCardInfoModule,
    ProductPriceModule,
    ProductLabelModule,
    TooltipModule.forRoot(DefaultTooltipOptions as TooltipOptions),
    ProductVariantsModule,
    ProductPartInfoInteractionComponentModule,
    QtyStepperModule
  ]
})
export class ProductCardModule {
}
